import { Outlet, useLocation } from 'react-router-dom';
import { learnPageFromPath, LearnPages } from '../../../../common/src/pages.ts';
import { OuterPageContent } from '../../util/shared.tsx';
import { Footer } from '../footer.tsx';
import { Header } from '../header.tsx';
import { LearnHub } from './learn_hub.tsx';
import { LearnUpdateAppPage } from './learn_update_app_screen.tsx';
import { getLearnTabAccess, LearnTabAccess } from './learn_visibility.ts';

// Learn tab (issue #3470): the hub at /learn, or a child route's page - a class screen
// (/learn/pitch) or an exercise (/learn/pitch/match, /learn/range), issue #3719.
// Open in browsers and in store apps new enough for the exercises; an older store app gets the update
// screen at every /learn path instead (see learn_visibility.ts).
export const LearnPage = () => {
  const access = getLearnTabAccess();
  const subPage = useLearnPage();

  if (access === LearnTabAccess.UpdateApp) {
    return <LearnUpdateAppPage />;
  }

  if (subPage) {
    return <Outlet />;
  }

  return (
    <OuterPageContent>
      <Header title="Learn" showProfileAvatar />
      <LearnHub />
      <Footer />
    </OuterPageContent>
  );
};

// The Learn sub-page the current location names, or undefined on the hub
export function useLearnPage(): LearnPages | undefined {
  const { pathname } = useLocation();
  return learnPageFromPath(pathname);
}
